import React from 'react';
import ReactSelect from 'react-select';

const SelectSearch = ({
  title,
  name,
  value,
  onChange,
  options,
  placeholder = "Seleccione",
  isDisabled = false,
  isClearable = true,
  isLoading = false,
  horizontal=true,
  noOptionsMessage = "No se encontraron opciones",
  loadingMessage = "Cargando...",
  maxMenuHeight = 200,
  required,
  isMulti = false
}) => {
  return (
        <div className= {`flex ${horizontal === true ? "flex-row items-center" : "flex-col"} justify-center w-full gap-2`}>
          {title && (
            <p className="font-itcbook text-[14px] md:text-[16px] text-[#111928] ">
            {title}
                 {required && <span className="text-red-500">*</span>}
            </p>
          )}
          <ReactSelect
            isMulti={isMulti}
            name={name}
            value={value}
            onChange={(selectedOption) => {
              if (onChange) {
                onChange(selectedOption);
              }
            }}
            options={options}
            placeholder={required && !title && placeholder ? `${placeholder} *` : placeholder}
            isDisabled={isDisabled}
            isClearable={isClearable}
            isSearchable
            isLoading={isLoading}
            noOptionsMessage={() => noOptionsMessage}
            loadingMessage={() => loadingMessage}
            maxMenuHeight={maxMenuHeight}
            closeMenuOnSelect={!isMulti}
            styles={{
              control: (base, state) => ({
                ...base,
                height: isMulti ? 'auto' : '40px',
                border: '1px solid #D1D5DB',
                borderRadius: '6px',
                boxShadow: state.isFocused ? 'none' : base.boxShadow,
                borderColor: state.isFocused ? '#D1D5DB' : base.borderColor,
                '&:hover': {
                  borderColor: '#D1D5DB'
                }
              }),
              placeholder: (base) => ({
                ...base,
                color: '#6B7280',
                fontSize: '14px',
                fontFamily: 'ITC-book',
                whiteSpace: 'nowrap',       
                overflow: 'hidden',         
                textOverflow: 'ellipsis',   
                maxWidth: '90%' 
              }),
              menu: (base) => ({
                ...base,
                borderRadius: '8px',
                overflow: 'hidden'
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: `${maxMenuHeight}px`, 
                overflowY: 'auto'
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? '#E6F7FF' : state.isFocused ? '#F7F8F9' : 'white',
                color: '#1B1F26',
                fontFamily: 'ITC-book',
                fontSize: '14px',
                '&:active': {
                  backgroundColor: '#E6F7FF'
                }
              }),
              singleValue: (base) => ({
                ...base,
                color: '#1B1F26',
                fontFamily: 'ITC-book',
                fontSize: '14px'
              })
            }}
          />
</div>
  );
};

export default SelectSearch;